import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1209.41883,643.473317 C1097.6977,578.713656 966.998976,579.356964 850.667466,645.510458 L797.701783,552.230814 C945.877034,467.957481 1119.99904,467.528609 1263.24226,550.944199 L1209.41883,643.473317 Z M643.30789,960.731324 C584.016346,960.731324 536.089908,912.804886 536.089908,853.513343 C536.089908,794.221799 584.016346,746.295361 643.30789,746.295361 C702.492215,746.295361 750.525871,794.221799 750.525871,853.513343 C750.525871,912.804886 702.492215,960.731324 643.30789,960.731324 L643.30789,960.731324 Z M1908.26564,791.541349 C1879.74565,676.603673 1784.85774,604.338753 1687.18216,604.767625 C1552.19472,386.150161 1365.95709,298.660288 1230.64799,264.02888 C1050.73622,217.81793 866.106855,241.405886 755.35068,291.047811 C646.631647,189.083511 474.546787,180.0772 344.491375,275.71564 L299.995913,308.417124 L334.091231,351.947625 C358.322495,382.719185 388.665183,436.11374 409.358254,494.976412 C327.979806,556.090662 257.001502,671.028338 232.12693,760.555353 C189.239738,790.898041 125.33782,808.052918 53.6089908,808.052918 L0,808.052918 L0,1092.9311 C0,1203.2584 65.9390587,1277.34602 176.588016,1290.96271 C230.51866,1297.61022 254.535488,1323.23532 290.882384,1362.15545 C333.233487,1407.40144 384.162028,1462.08261 490.30783,1486.42109 C472.080773,1538.74346 445.16906,1607.14854 432.731774,1637.49122 L402.817957,1711.2572 L755.565116,1711.2572 C815.92884,1711.2572 863.104752,1682.52278 884.548348,1633.52416 L919.394192,1557.39939 C923.146822,1548.17865 942.87493,1533.27535 960.351461,1532.73926 C986.512649,1531.98873 1041.0866,1532.31038 1087.19033,1532.63204 L1140.90654,1532.84647 C1146.91075,1532.84647 1159.56247,1532.84647 1177.57509,1563.61803 L1216.92409,1632.77363 C1242.76362,1680.48563 1291.22615,1710.18502 1343.33409,1710.18502 L1662.4148,1711.57885 L1595.72522,1424.98518 C1718.16816,1345.64388 1799.22495,1207.01103 1801.47653,1073.09577 C1906.65737,1012.19596 1940.53825,922.025633 1908.26564,791.541349 L1908.26564,791.541349 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBankSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconBankSolid, _Component);

  var _super = _createSuper(IconBankSolid);

  function IconBankSolid() {
    _classCallCheck(this, IconBankSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconBankSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBank",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBankSolid.displayName = "IconBankSolid";
  return IconBankSolid;
}(Component);

IconBankSolid.glyphName = 'bank';
IconBankSolid.variant = 'Solid';
IconBankSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBankSolid;
export { IconBankSolid };